import { useDatoQuerySubscription } from '@src/hooks/useDatoQuerySubscription';
import { useEffect } from 'react';

import { SHOWCASE_ARTIFACTS_VIDEO_QUERY } from '../gql/media-gql';

import type { ShowcaseArtifactsVideoUpdate } from '../types.ts/story';

export const useQueryShowcaseVideos = (
  ids: string[],
): {
  status: string;
  error: any;
  data: { allShowcases: ShowcaseArtifactsVideoUpdate[] } | undefined;
} => {
  const { status, error, data } = useDatoQuerySubscription<
    { allShowcases: ShowcaseArtifactsVideoUpdate[] },
    { ids: string[] }
  >({
    query: SHOWCASE_ARTIFACTS_VIDEO_QUERY,
    variables: { ids },
  });

  return { status, error, data };
};

const OrganizationArtifactsVideoSubscription = (props: {
  organizationIds: string[];
  onDataReceived: (updates: ShowcaseArtifactsVideoUpdate[]) => void;
  onError: (error: any) => void;
}) => {
  const { organizationIds, onDataReceived, onError } = props;
  const { error, data } = useQueryShowcaseVideos(organizationIds);

  useEffect(() => {
    if (error) {
      onError(error);
    } else if (data?.allShowcases?.length) {
      onDataReceived(data.allShowcases);
    }
  }, [data, error]);

  return <></>;
};

export default OrganizationArtifactsVideoSubscription;
